import React, { useEffect, useState } from 'react'
import {
  Container,
  Icon,
  Image,
  ToastContext,
  Tools
} from '@pmi/pmi-iqos-ds-react'
import {
  Assets,
  analytics,
  goToRoute,
  Routes,
  localstorage
} from '@pmi/pmi-iqos-shared-react'
import { useDebounce } from '@iqosphere-common/utils'
import SpotsFiltersTop from './spots-filters-top'
import SpotsMapDetailPopup from './spots-map-detail-popup'

const SpotsMapView = ({
  translations,
  showListPage,
  businessTypes,
  usageTypes,
  filters,
  spots,
  map,
  toggleFilterHandler,
  loadData,
  handleGoCurrentLocation,
  mapConfig,
  mapDomId,
  setUserLocationSearched,
  debounceDelay,
  userLocation
}) => {
  const [searchInputValue, setSearchInputValue] = useState('')
  const [showDetailPopup, setShowDetailPopup] = useState(false)
  // const [spotSelected, setSpotSelected] = useState({})
  const [fullDetail, setFullDetail] = useState(false)
  const [mapCenter, setMapCenter] = useState(null)
  const debouncedMovingMap = useDebounce(mapCenter, debounceDelay)
  const [markers, setMarkers] = useState([])
  const [searchedLocation, setSearchedLocation] = useState(false)

  const popupToast = ToastContext.getContextActions().popupToast

  const handleToGetRadius = (map, center) => {
    let radius = mapConfig.radius
    const bounds = map.getBounds()
    if (bounds && center) {
      const ne = bounds.getNorthEast()
      // Calculate radius (in meters).
      // eslint-disable-next-line no-undef
      radius = google.maps.geometry.spherical.computeDistanceBetween(center, ne)
    }
    const radiusDistance = parseInt(radius.toFixed(0))
    return radiusDistance
  }

  useEffect(() => {
    // load data when map is setted (first time, moved by drag or search by city name)
    if (debouncedMovingMap) {
      const center = map.getCenter()
      const radius = handleToGetRadius(map, center)
      setUserLocationSearched({ lat: center.lat(), lng: center.lng() })

      const data = {
        ...mapConfig,
        radius: radius,
        lat: center.lat(),
        lng: center.lng()
      }
      loadData(data, filters)

      const mapDataInfo = {
        lat: center.lat(),
        lng: center.lng(),
        zoom: map.getZoom()
      }
      localstorage.set('SpotMapDataInfo', mapDataInfo)
    }
  }, [debouncedMovingMap])

  useEffect(() => {
    if (map) {
      setMapCenter(map.getCenter())
    }
  }, [map])

  useEffect(() => {
    const arrayMarkers = []
    if (map) {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null)
      }
      spots &&
        spots.map(spot => {
          if (spot.lat && spot.lng) {
            const location = {
              lat: spot.lat,
              lng: spot.lng
            }

            const iconDefault =
              businessTypes &&
              businessTypes.find(element => parseInt(element.id) === 101)
                .iconSpot

            const spotBusinessType =
              businessTypes &&
              businessTypes.find(
                element => parseInt(element.id) === spot.businessType
              )

            const image = {
              url: spotBusinessType ? spotBusinessType.iconSpot : iconDefault,
              // eslint-disable-next-line no-undef
              size: new google.maps.Size(40, 60),
              // eslint-disable-next-line no-undef
              origin: new google.maps.Point(0, 0),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(20, 60)
            }

            // eslint-disable-next-line no-undef
            const marker = new google.maps.Marker({
              position: location,
              map: map,
              icon: image
            })
            arrayMarkers.push(marker)
            marker.addListener('click', () => {
              // PMIRRPJP-51333 - Remove map overlays
              // setShowDetailPopup(true)
              // setSpotSelected(spot)
              goToRoute({
                mainPath: `${Routes.spotListPage}/${spot.spotId}#map`
              })
            })
          }
        })
      if (userLocation) {
        const imageUserLocation = {
          url: Assets.urls.iconSpotUserCurrentLocation,
          // eslint-disable-next-line no-undef
          size: new google.maps.Size(50, 50),
          // eslint-disable-next-line no-undef
          origin: new google.maps.Point(0, 0),
          // eslint-disable-next-line no-undef
          anchor: new google.maps.Point(25, 25)
        }
        // eslint-disable-next-line no-undef
        const markerUserLocation = new google.maps.Marker({
          position: userLocation,
          map: map,
          icon: imageUserLocation
        })
        arrayMarkers.push(markerUserLocation)
      }

      setMarkers(arrayMarkers)
      map.addListener('center_changed', () => {
        setMapCenter(map.getCenter())
      })
    }
  }, [spots, map])

  const handleClearSearchInput = () => {
    setSearchInputValue('')
    setSearchedLocation(false)
  }

  const handleChangeSearchInput = e => {
    setSearchInputValue(e.target.value)
  }

  const handleSearchLocation = async e => {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: searchInputValue }, function (results, status) {
      setSearchedLocation(true)
      if (status === 'OK') {
        map.setCenter(results[0].geometry.location)
        map.setZoom(14)
      } else {
        popupToast({
          type: ToastContext.types.error,
          title: `${translations.tk_geocodeError}`
        })
      }
    })
  }

  const handleCloseDetailPopup = () => {
    setShowDetailPopup(false)
    setFullDetail(false)
  }

  const handleShowListPage = () => {
    showListPage()
    analytics.onClickSpotListPage()
  }

  const handleAboutSpotBtn = () => {
    analytics.onClickSpotAboutBtn()
    goToRoute({ mainPath: Routes.spotWelcomePage })
  }

  return (
    <>
      <Container
        position={Container.positions.absolute}
        pt={['4', '8', '12']}
        zIndex="1"
        r="0"
        t="0"
        l="0">
        <SpotsFiltersTop
          translations={translations}
          filters={filters}
          handleChangeSearchInput={handleChangeSearchInput}
          handleClearSearchInput={handleClearSearchInput}
          searchInputValue={searchInputValue}
          handleGoCurrentLocation={handleGoCurrentLocation}
          toggleFilterHandler={toggleFilterHandler}
          // spot={spotSelected}
          usageTypes={usageTypes}
          onCloseHandler={() => setShowDetailPopup(false)}
          showDetailPopup={showDetailPopup}
          fullDetail={fullDetail}
          setFullDetail={setFullDetail}
          handleSearchLocation={handleSearchLocation}
          searchedLocation={searchedLocation}
        />
      </Container>
      <Container
        position={Container.positions.absolute}
        r="0"
        t="0"
        l="0"
        b="0"
        overflowHidden>
        <Container height="screen" id={mapDomId} />
      </Container>

      <Container
        position={Container.positions.absolute}
        zIndex={fullDetail ? '1' : '2'}
        t={fullDetail ? '0' : null}
        b="0"
        l="0">
        <Container px={['4', '20']} pb={['6', '10']}>
          <Container
            px="4"
            py="3"
            display={Container.displays.flex}
            bg={Container.backgrounds.turquoise}
            onClickHandler={handleAboutSpotBtn}
            additionalClasses="q-rounded-full"
            shadow
            data-testing="SpotsFiltersTop_Button_AboutSpot">
            <Icon size={Icon.sizes.s} image={Icon.images.info} />
            <Container pl="2">{translations.tk_aboutSpotBtn}</Container>
          </Container>
        </Container>
      </Container>
      <Container
        position={Container.positions.absolute}
        zIndex={fullDetail ? '1' : '2'}
        t={fullDetail ? '0' : null}
        b="0"
        r="0">
        <Container px={['4', '20']} pb="4">
          <Container
            width="14"
            height="14"
            p="4"
            display={Container.displays.flex}
            bg={Container.backgrounds.white}
            onClickHandler={handleGoCurrentLocation}
            additionalClasses="q-rounded-full"
            shadow
            data-testing="SpotsFiltersTop_Button_GotoCurrentLocation">
            <Image src={Assets.urls.iconSpotCurrentLocation} />
          </Container>
        </Container>
        <Container px={['4', '20']} pb={['6', '10']}>
          <Container
            width="14"
            height="14"
            p="4"
            display={Container.displays.flex}
            bg={Container.backgrounds.white}
            onClickHandler={handleShowListPage}
            additionalClasses="q-rounded-full"
            shadow
            data-testing="SpotsFiltersTop_Button_ShowListView">
            <Image src={Assets.urls.iconSpotList} />
          </Container>
        </Container>
      </Container>
      <Container
        position={Container.positions.absolute}
        zIndex={fullDetail ? '1' : '2'}
        t={fullDetail ? '0' : null}
        b="0"
        l="0"
        r="0">
        {!Tools.isDesktop() && showDetailPopup ? (
          <Container
            height={[fullDetail ? 'full' : 'auto', 'auto']}
            data-testing="SpotsMapView_Container_DetailPopup">
            <SpotsMapDetailPopup
              // spot={spotSelected}
              usageTypes={usageTypes}
              onCloseHandler={handleCloseDetailPopup}
              translations={translations}
              fullDetail={fullDetail}
              setFullDetail={setFullDetail}
            />
          </Container>
        ) : null}
      </Container>
    </>
  )
}

export default SpotsMapView
